import { motion } from "framer-motion";

import LanguageToggle from "./LanguageToggle";
import RichText from "../i18n/RichText";
import { useLanguage } from "../i18n/LanguageContext";

const Navbar = () => {
  const { t } = useLanguage();

  return (
    <motion.div 
      initial={{ opacity: 0, y: -30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="landscapes:py-2 bg-gradient-to-r from-[#23180E] to-transparent absolute top-0 z-[99] w-full p-3 2xl:px-7 2xl:py-5"
    >
      <div className="w-full flex justify-between items-center">
        <div className="flex items-center gap-x-2 md:gap-x-3 2xl:gap-x-7">
          <div className="landscapes:text-[17px] text-lg 2xl:text-3xl 3xl:text-4xl barrio-regular text-white">
            P.U.R.B.A.
          </div>
          <div className="landscapes:text-[7px] text-white text-[9px] 2xl:text-[12px] 3xl:text-sm leading-tight trajanpro-bold">
            <RichText text={t("navbar.subtitle")} />
          </div>
        </div>
        <div className="flex shrink-0 items-center justify-end gap-x-1.5 md:gap-x-2 2xl:gap-x-5">
          <LanguageToggle />
          <img
            className="landscapes:w-[29vw] w-[26vw] md:w-[38vw] 2xl:w-[19vw] object-contain"
            src="/assets/images/logos.png"
            alt={t("alt.partners")}
            width="521"
            height="73"
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Navbar;